/** Query `reason` en redirect a main-view — Fase 3 UX */
export const ROUTE_ACCESS_REASON = {
    NO_CURSO: "no-curso",
    FORBIDDEN_ROLE: "forbidden-role",
    FORBIDDEN_DIRECTIVA: "forbidden-directiva",
    FORBIDDEN_DIRECTIVA_CONFIG: "forbidden-directiva-config",
    FORBIDDEN_CPA: "forbidden-cpa",
    FORBIDDEN_TESORERIA_TYPE: "forbidden-tesoreria-type",
    FORBIDDEN_PUPIL_REQUIRED: "forbidden-pupil-required",
    FORBIDDEN_ADMIN: "forbidden-admin",
};
export const messageForRouteAccessReason = (reason) => {
    switch (reason) {
        case ROUTE_ACCESS_REASON.NO_CURSO:
            return {
                title: "Curso requerido",
                message: "Selecciona un curso en el menú superior para acceder a esa pantalla.",
            };
        case ROUTE_ACCESS_REASON.FORBIDDEN_ROLE:
            return {
                title: "Acceso restringido",
                message: "Tu rol en el curso activo no tiene permiso para abrir esa pantalla.",
            };
        case ROUTE_ACCESS_REASON.FORBIDDEN_DIRECTIVA:
            return {
                title: "Acceso restringido",
                message: "Solo la directiva del curso (presidente, tesorero o secretario) puede acceder.",
            };
        case ROUTE_ACCESS_REASON.FORBIDDEN_DIRECTIVA_CONFIG:
            return {
                title: "Acceso restringido",
                message: "Solo el presidente o tesorero puede modificar la configuración del curso.",
            };
        case ROUTE_ACCESS_REASON.FORBIDDEN_CPA:
            return {
                title: "Acceso restringido",
                message: "Esta sección es solo para la directiva del Centro de Padres y Apoderados.",
            };
        case ROUTE_ACCESS_REASON.FORBIDDEN_TESORERIA_TYPE:
            return {
                title: "No disponible",
                message: "Esa pantalla no aplica al tipo de tesorería del curso seleccionado.",
            };
        case ROUTE_ACCESS_REASON.FORBIDDEN_PUPIL_REQUIRED:
            return {
                title: "No disponible en este grupo",
                message: "Esta función solo está disponible en grupos donde los usuarios representan a pupilos.",
            };
        case ROUTE_ACCESS_REASON.FORBIDDEN_ADMIN:
            return {
                title: "Acceso restringido",
                message: "No tienes permisos de administrador de plataforma.",
            };
        default:
            return reason
                ? {
                    title: "Acceso restringido",
                    message: "No puedes acceder a la pantalla solicitada.",
                }
                : null;
    }
};
